export class amountHelper {
    static getLocaleString(amount: number, currency: string, decimalDigits: number = 0) {
        return this.getLocaleStringWithDigitRange(amount, currency, decimalDigits, decimalDigits)
    }

    static getLocaleStringWithDigitRange(amount: number, currency: string, minDecimalDigits: number, maxDecimalDigits: number) {
        // pt-BR thousand: 1.000,000
        // en-US thousand: 1,000.000
        // en-IN format: 1,00,00,000
        amount = Math.floor(amount * 100) / 100
        const locale
            = {
                THB: 'en-US',
                MYR: 'en-US',
                KRW: 'en-US',
                INR: 'en-IN',
                JPY: 'en-US',
                CNY: 'en-US',
                BRL: 'pt-BR',
                VND: 'pt-BR',
                MMK: 'en-US',
                IDR: 'pt-BR',
                BDT: 'en-US', // BDT Agent wants en-US format, but they don't say why
                KHR: 'km-KH',
            }[currency] ?? 'en-US'

        return amount.toLocaleString(locale, {
            minimumFractionDigits: minDecimalDigits,
            maximumFractionDigits: maxDecimalDigits,
        })
    }

    static getLocaleStringWithSymbol(amount: number, currency: string, decimalDigits: number = 0) {
        // e.g. 10000000.99
        // pt-BR format: 10.000.000,99
        // en-US format: 10,000,000.99
        // en-IN format: 1,00,00,000.99
        try {
            amount = Math.floor(amount * 100) / 100
            const lang
                = {
                    THB: 'en-US',
                    MYR: 'en-US',
                    KRW: 'en-US',
                    INR: 'en-IN',
                    JPY: 'en-US',
                    CNY: 'en-US',
                    BRL: 'pt-BR',
                    VND: 'vi-VN',
                    MMK: 'en-US',
                    IDR: 'pt-BR',
                    BDT: 'en-US',
                    KHR: 'km-KH',
                }[currency] ?? 'en-US'

            let prefixSymbol = ''
            let formatNumber = ''
            let postfixSymbol = ''
            const isoFormat = ['MMK', 'UST']
            if (isoFormat.includes(currency)) {
                prefixSymbol = currency === 'UST' ? 'USDT' : currency
                formatNumber = amount.toLocaleString(lang, {
                    minimumFractionDigits: decimalDigits,
                })
            }
            else {
                const formatted = new Intl.NumberFormat(lang, {
                    style: 'currency',
                    currency,
                    currencyDisplay: 'narrowSymbol',
                    minimumFractionDigits: decimalDigits,
                }).format(amount)
                const regex = /^([^\d\s,.]+)?\s*([\d,.]+)\s*([^\d\s,.]+)?/
                const match = regex.exec(formatted)
                if (match) {
                    [, prefixSymbol = '', formatNumber, postfixSymbol = ''] = match
                }
                if (currency === 'KHR') {
                    postfixSymbol = prefixSymbol
                    prefixSymbol = ''
                }
            }
            return `${prefixSymbol}${prefixSymbol.length > 1 ? ' ' : ''}${formatNumber}${postfixSymbol ? ` ${postfixSymbol}` : ''}`
        }
        catch {
            return `${currency} ${this.getLocaleString(amount, currency, decimalDigits)}`
        }
    }

    static getLocaleDecimalSign(currency: string): string {
        return this.getLocaleString(0.1, currency, 1).replace(/\d/g, '')
    }

    static getLocaleThousandSign(currency: string): string {
        return this.getLocaleString(1000, currency, 0).replace(/\d/g, '')
    }
}
